import { Schema as S } from "effect";

import { defineApi, staticApis } from "../client";

export const DigestPreferences = S.Struct({ subscribed: S.Boolean });
export type DigestPreferences = typeof DigestPreferences.Type;

export const { getDigestPreferences } = staticApis({
	getDigestPreferences: ["GET", "/digest/preferences", DigestPreferences],
});

export const setDigestPreferences = defineApi("SetDigestPreferences", {
	args: { subscribed: S.Boolean },
	response: DigestPreferences,
	request: (body) => ({ method: "PUT", path: "/digest/preferences", body }),
});
